module.exports = __webpack_public_path__ + "img/Wp_2004.e35b6170.png";